import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a4b1710a-e8aa-40f2-90ed-6aa15c96d321/artifacts/w14lowsf_Disen%CC%83o%20sin%20ti%CC%81tulo.png";

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Brand */}
          <Link to="/" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="JG Models Agency" className="h-8 w-auto" />
          </Link>

          {/* Copyright */}
          <p className="text-sm text-white/50 text-center">
            © {new Date().getFullYear()} JGlinks. Todos los derechos reservados.
          </p>

          {/* Links */}
          <div className="flex items-center gap-6">
            <Link 
              to="/explorar" 
              className="text-sm text-white/50 hover:text-white transition-colors"
            >
              Explorar
            </Link>
            <span className="text-white/20">|</span>
            <span className="text-sm text-pink-500 font-medium">
              +18 Only
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
